var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { connect } from "react-redux";
import "./LoginPage.scss";
import { userManagerInit } from "../../store/actions/userManager";
var LoginPage = (function (_super) {
    __extends(LoginPage, _super);
    function LoginPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginPage.prototype.onLoginButtonClick = function (idpConf) {
        localStorage.setItem('lastIdpUsed', idpConf.id);
        this.props.userManagerInit(__assign(__assign({}, idpConf), { login: true }));
    };
    LoginPage.prototype.render = function () {
        var _this = this;
        var _a = this.props, loginText = _a.loginText, idpConfigs = _a.serviceProperties.idpConfigs;
        return (React.createElement("div", { className: "df-login-page" },
            React.createElement("div", { className: "df-login-main-container" },
                React.createElement("div", { className: "df-login-logo-container" }),
                idpConfigs.map(function (currentConf) {
                    var id = currentConf.id;
                    return React.createElement("div", { className: "df-login-button", onClick: _this.onLoginButtonClick.bind(_this, currentConf), key: id },
                        React.createElement("span", { className: "df-login-button-logo df-login-button-logo-" + id }),
                        React.createElement("span", { className: "df-login-button-text" }, loginText[id]));
                }))));
    };
    return LoginPage;
}(React.Component));
function mapStateToProps(state) {
    return {
        userManager: state.userManager,
        serviceProperties: state.serviceProperties
    };
}
var mapDispatchToProps = {
    userManagerInit: userManagerInit
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
